import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEmailNotificationType implements BaseEnumType {
  private static allValues: EnumEmailNotificationType[] = []; // make sure this is top-most
  
  public static orderDispatch = new EnumEmailNotificationType(0, "OrderDispatch", "enum_email_notification_type_order_dispatch");
  public static orderConfirmation = new EnumEmailNotificationType(1, "OrderConfirmation", "enum_email_notification_type_order_confirmation");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEmailNotificationType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOrderDispatch() { return this === EnumEmailNotificationType.orderDispatch; }
  public isOrderConfirmation() { return this === EnumEmailNotificationType.orderConfirmation; }

  public static getValues(): readonly EnumEmailNotificationType[] {
    return EnumEmailNotificationType.allValues;
  }

  public static getValuesExcept0(): readonly EnumEmailNotificationType[] {
    return EnumEmailNotificationType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEmailNotificationType {
    const found = EnumEmailNotificationType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEmailNotificationType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEmailNotificationType): EnumEmailNotificationType {
    const found = name ? EnumEmailNotificationType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEmailNotificationType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEmailNotificationType>): boolean {
    return this.key === other?.key;
  }
}